module.exports = __webpack_public_path__ + "c4dbaa9ac40d54d60dae38b11534217b.png";